import {createApi} from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../axiosBaseQuery";
import {UserDataType} from "../../store/actions/userSlice";
import {setLoggedIn, setLoggedOut} from "../../store/actions/userSlice";
import {closeLoginDialog} from "../../store/actions/loginDialogSlice";
import {
  GetProfileResponse,
  parseGetProfileResponse,
} from "../../api/user/get-profile";
import {mockTestApiSlice} from "../../features/mock-test-table/store/api/mockTestApiSlice";
import {problemsetApiSlice} from "./problemsetApiSlice";

export const userApiSlice = createApi({
  reducerPath: "userApi",
  baseQuery: axiosBaseQuery(),
  tagTypes: ["User"],
  endpoints: builder => ({
    // GetProfile error signifying that user is not logged in
    getProfile: builder.query<UserDataType, void>({
      query: () => ({
        url: "/users/profile/",
        method: "GET",
      }),
      transformResponse: (response: GetProfileResponse) =>
        parseGetProfileResponse(response),
      providesTags: ["User"],
    }),

    googleLogin: builder.mutation<any, string>({
      query: accessToken => ({
        url: "/users/login/",
        method: "POST",
        data: {
          access_token: accessToken,
        },
      }),
      async onQueryStarted(_, {dispatch, queryFulfilled}) {
        try {
          await queryFulfilled;
          dispatch(closeLoginDialog());
          dispatch(setLoggedIn()); // TODO: To be removed when userSlice is deprecated

          // Invalidate User tags in all API slices
          dispatch(mockTestApiSlice.util.invalidateTags(["User"]));
          dispatch(problemsetApiSlice.util.invalidateTags(["User"]));
        } catch (error) {
          // ERROR: Silent fail - error handling will be done by component
        }
      },
      invalidatesTags: ["User"],
    }),

    logout: builder.mutation<any, void>({
      query: () => ({
        url: "/users/logout/",
        method: "POST",
      }),
      async onQueryStarted(_, {dispatch, queryFulfilled}) {
        try {
          await queryFulfilled;
          dispatch(setLoggedOut()); // TODO: To be removed when userSlice is deprecated

          // Invalidate User tags in all API slices
          dispatch(mockTestApiSlice.util.invalidateTags(["User"]));
          dispatch(problemsetApiSlice.util.invalidateTags(["User"]));
        } catch (error) {
          // ERROR: Silent fail - error handling will be done by component
        }
      },
      invalidatesTags: ["User"],
    }),
  }),
});

export const {useGetProfileQuery, useGoogleLoginMutation, useLogoutMutation} =
  userApiSlice;
